module.exports = __webpack_public_path__ + "media/images/home/grubhub-badf53120104d39c7da1313b95cd4c04.png";